
import { Component, Mixins } from "vue-property-decorator";
import {
  Document,
} from "../../../../domain/document";
import { EditingDocument } from "..";

@Component({
})
export default class DocumentQuotableMixin extends Mixins() {
  editingSource: EditingDocument;

  /**
   * 編集中の文書に別の文書の内容を引っ張ってくる
   * マスターコードが同じ：ObjectIdをキーにする
   * マスターコードが違う：名称をキーにする
   */
  public async quoteDocumentAsync(source: Document): Promise<void> {
    const cloned = this.editingSource.clone();
    const isExternalScriptSuccess = await cloned.merge(source);
    if (!isExternalScriptSuccess) {
      this.$error("外部スクリプト", "外部スクリプトの実行中にエラーが発生しています。");
    }
    this.editingSource = cloned;
  }
}
